import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getFlutes } from "@/api/corrugates-api";
import type { Flute } from "@/views/production/saved-jobs/types/dependencies";

export const FLUTES_QUERY_KEY = ["flutes"] as const;

type UseFlutesQueryOptions = Omit<
	UseQueryOptions<Flute[], Error, Flute[], typeof FLUTES_QUERY_KEY>,
	"queryKey" | "queryFn"
>;

export const useFlutes = (queryConfig: UseFlutesQueryOptions = {}) => {
	const query = useQuery({
		queryKey: FLUTES_QUERY_KEY,
		queryFn: getFlutes,
		...queryConfig,
	});

	return {
		flutes: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
